import { Injectable } from '@angular/core';

import { Categoria } from "./categoria.model";
import { apiName } from "./data.service";
import { RestService } from "../../../core/services/rest.service";

@Injectable()
export class CategoriaApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Categoria, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Categoria, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        var filter: any = {"order":"categoria","where":{"ativo":true}};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        this._restService.onGetPostId(apiName, objectId, {}, done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/categorias/shared/categoria-api.service.ts
 **/